import * as Scrivito from "scrivito";
import isValidContent from "^/utils/isValidContent";
import PageIsGoneException from "^/utils/PageIsGoneException";
import setLanguage from "^/utils/setLanguage";
import StoryPage from "../../Components/StoryPage";

Scrivito.provideComponent(
  "NewsPage",
  Scrivito.connect(({ page }) => {
    setLanguage(page);
    if (
      !Scrivito.isInPlaceEditingActive() &&
      !isValidContent(page.get("publishFromDate"), page.get("publishUntilDate"))
    ) {
      throw new PageIsGoneException();
    }
    return <StoryPage page={page} />;
  })
);
